module.exports = __webpack_public_path__ + "img/index-xsjl2.498841b1.png";